module.exports = "/images/vendor/dhtmlx-scheduler/codebase/imgs_dhx_material/agenda-calendar.svg?3e1b8ebc2e651ee7eb5f132d37e64da2";